import React from 'react';
import { Link } from 'react-router-dom';

interface NavbarLogoProps {
  isPublicSite: boolean;
  isHomePage: boolean;
}

export const NavbarLogo: React.FC<NavbarLogoProps> = ({ isPublicSite, isHomePage }) => {
  return (
    <div className="flex-shrink-0 -ml-4">{/* Added -ml-4 to move logo left */}
      <Link 
        to={isPublicSite ? "/" : "/Blog-Page-Builder"} 
        className="flex items-center space-x-3 group"
      >
        {isPublicSite ? (
          <>
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110">
              <img 
                src="/lovable-uploads/4a216dc2-3cfa-4c6d-b87f-d5154c1486d7.png" 
                alt="Carolina Trophy Roofs Logo" 
                className="w-12 h-12 md:w-16 md:h-16 object-contain rounded-xl drop-shadow-lg hover:drop-shadow-xl transition-all duration-300"
                loading="eager"
                fetchPriority="high"
                decoding="async"
                width="64"
                height="64"
              />
            </div>
          </>
        ) : (
          <>
            <div className="w-15 h-15 rounded-xl bg-gradient-to-br from-brand-charcoal-gray to-gray-800 flex items-center justify-center border-2 border-gray-600 shadow-lg shadow-gray-400/50 group-hover:scale-110 group-hover:shadow-gray-300/60 transition-all duration-300">
              <span className="text-xl font-bold text-white">B</span>
            </div>
            <div className="hidden sm:block">
              <span className="text-xl font-bold text-gray-900">
                BlogCraft<span className="text-brand-trophy-gold">AI</span>
              </span>
            </div>
          </>
        )}
      </Link>
    </div>
  );
};